__turbopack_context__.v({
  "modalWrapper": "C5q-kW_modalWrapper",
  "postalCodeLabel": "C5q-kW_postalCodeLabel",
  "postalCodeTitle": "C5q-kW_postalCodeTitle",
  "postalCodeWrapper": "C5q-kW_postalCodeWrapper",
  "warning": "C5q-kW_warning",
  "warningUnset": "C5q-kW_warningUnset",
});
